module.exports = __webpack_public_path__ + "img/lx-img5.c6995ff6.png";